export function resolveAccountPageRoot(documentRef) {
    const page = documentRef.querySelector('[data-page-view="account"]');
    if (!(page instanceof HTMLElement)) {
        return null;
    }

    return page;
}

export function readAccountPageCsrfToken(documentRef) {
    const meta = documentRef.querySelector('meta[name="csrf-token"]');
    if (!(meta instanceof HTMLMetaElement)) {
        return '';
    }

    return meta.content;
}

export function resolveChangeEmailForm(page) {
    const form = page.querySelector('[data-account-change-email-form]');
    if (!(form instanceof HTMLFormElement)) {
        return null;
    }

    const passwordInput = form.querySelector('input[name="password"]');
    const emailInput = form.querySelector('input[name="new_email"]');
    const submitButton = form.querySelector('[data-account-change-email-submit]');
    const passwordField = passwordInput?.parentElement;
    const emailField = emailInput?.parentElement;

    if (!(passwordInput instanceof HTMLInputElement)
        || !(emailInput instanceof HTMLInputElement)
        || !(submitButton instanceof HTMLButtonElement)
        || !(passwordField instanceof HTMLElement)
        || !(emailField instanceof HTMLElement)) {
        return null;
    }

    return {
        form,
        passwordInput,
        emailInput,
        passwordField,
        emailField,
        submitButton,
    };
}

export function resolveChangePasswordForm(page) {
    const form = page.querySelector('[data-account-change-password-form]');
    if (!(form instanceof HTMLFormElement)) {
        return null;
    }

    const currentPasswordInput = form.querySelector('input[name="current_password"]');
    const newPasswordInput = form.querySelector('input[name="new_password"]');
    const confirmPasswordInput = form.querySelector('input[name="confirm_password"]');
    const submitButton = form.querySelector('[data-account-change-password-submit]');
    const currentPasswordField = currentPasswordInput?.parentElement;
    const newPasswordField = newPasswordInput?.parentElement;
    const confirmPasswordField = confirmPasswordInput?.parentElement;

    if (!(currentPasswordInput instanceof HTMLInputElement)
        || !(newPasswordInput instanceof HTMLInputElement)
        || !(confirmPasswordInput instanceof HTMLInputElement)
        || !(submitButton instanceof HTMLButtonElement)
        || !(currentPasswordField instanceof HTMLElement)
        || !(newPasswordField instanceof HTMLElement)
        || !(confirmPasswordField instanceof HTMLElement)) {
        return null;
    }

    return {
        form,
        currentPasswordInput,
        newPasswordInput,
        confirmPasswordInput,
        currentPasswordField,
        newPasswordField,
        confirmPasswordField,
        submitButton,
    };
}

export function resolveDeleteForm(page) {
    const form = page.querySelector('[data-account-delete-form]');
    if (!(form instanceof HTMLFormElement)) {
        return null;
    }

    const passwordInput = form.querySelector('input[name="password"]');
    const submitButton = form.querySelector('[data-account-delete-submit]');

    if (!(passwordInput instanceof HTMLInputElement)
        || !(submitButton instanceof HTMLButtonElement)) {
        return null;
    }

    return {
        form,
        passwordInput,
        submitButton,
    };
}
